import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { flatMap, map } from 'rxjs/operators';
import { ApiService, DataService, InspectionPluginService, LanguageService } from '../../../shared/services';
import { InspectionPlugin } from '../../../shared/models/index';
import { InspectionFactoryService } from '../../../shared/services/inspectionFactory.service';

@Injectable()
export class InstallationCustomerCommentsPluginService extends InspectionPluginService {
  public commentFromKeys: any = [
    { value: 1, label: 'plugins.installationcustomercomments.production-manager' },
    { value: 2, label: 'plugins.installationcustomercomments.project-manager' },
    { value: 3, label: 'plugins.installationcustomercomments.maintenance-manager' },
    { value: 4, label: 'plugins.installationcustomercomments.operator' },
    { value: 5, label: 'plugins.installationcustomercomments.plant-manager' },
    { value: 6, label: 'plugins.installationcustomercomments.other' }
  ];
  public commentFromTargets: any = [];

  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private inspectionFactory: InspectionFactoryService,
    private language: LanguageService
  ) {
    super(apiService, dataService, null);
    this.applyTranslations();
    this.language.onLanguageChange().subscribe((value) => this.applyTranslations());
  }

  public updateComments(inspectionId: string, pointId: string, pluginId: string, comments: any[]): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, comments).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  public getCommentFromTargets() {
    return this.commentFromTargets;
  }

  public applyTranslations() {
    this.commentFromTargets = [];
    this.copyTranslationValues(this.commentFromKeys, this.commentFromTargets, this.language);
  }

  private update(inspectionId: string, pointId: string, pluginId: string, comments: any[]): Observable<any> {
    return this.inspectionFactory.updatePluginConfig(inspectionId, pointId, pluginId, comments, 'Comments').pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
